import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getCurrentUser } from '@aws-amplify/auth';
import { useClient } from '../context/ClientContext.tsx';

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { expirationDate, subscriptionIsActive } = useClient();

  //Run authentication check ONCE (async)
  useEffect(() => {
    const checkUser = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };
    checkUser();
  }, []);

  //Still loading auth state
  if (isAuthenticated === null) return null; // or a spinner

  //Not logged in → redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/loginRedirect" replace />;
  }

  //Subscription check (runs on every render)
  /*
  const isValid =
    expirationDate instanceof Date &&
    !isNaN(expirationDate) &&
    expirationDate > new Date();
  */
  const isValid = subscriptionIsActive === true
    || (expirationDate instanceof Date &&
      !isNaN(expirationDate) &&
      expirationDate > new Date());

  if (!isValid) {
    return <Navigate to="/select-plan" replace />;
  }

  //Authenticated + subscription valid → allow access
  return <Outlet />;
};

export default PrivateRoute;